export default [
    {title: "Employee.Active", value: "Active"},
    {title: "Employee.Deactivate", value: "Deactivate"}
]
